import { withMetadata } from '../metadata'
import { getCountries as _getCountries } from '../../core/index'

export function getCountries() {
	return withMetadata(_getCountries, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getCountries.js
// module id = AgNn
// module chunks = 0 1